import React, { useMemo } from 'react';
import { Dropdown, FormLabel } from 'react-bootstrap';
import { Platform } from '../types/Platform';
import { useAppDispatch, useAppSelector } from '../store';

import { setParams } from '../reducers/paramsReducer';

export default function GamesFiltersTimeControls(): React.ReactNode {
  const dispatch = useAppDispatch();
  const { platform } = useAppSelector((state) => state.paramsReducer.params);

  const platformName = useMemo(
    () =>
      platform == Platform.ChessCom ? 'Chess.com' : platform == Platform.Lichess ? 'Lichess' : null,
    [platform],
  );
  return (
    <div>
      <FormLabel className="d-block">Platform</FormLabel>
      <Dropdown className="me-3">
        <Dropdown.Toggle className="cm-filter-select">{platformName ?? 'All'}</Dropdown.Toggle>
        <Dropdown.Menu className="cm-filter-menu">
          <Dropdown.Item
            active={platform == null}
            onClick={() => {
              dispatch(setParams({ platform: null }));
            }}
          >
            All
          </Dropdown.Item>
          <Dropdown.Item
            active={platform == Platform.ChessCom}
            onClick={() => {
              dispatch(setParams({ platform: Platform.ChessCom }));
            }}
          >
            Chess.com
          </Dropdown.Item>
          <Dropdown.Item
            active={platform == Platform.Lichess}
            onClick={() => {
              dispatch(setParams({ platform: Platform.Lichess }));
            }}
          >
            Lichess
          </Dropdown.Item>
        </Dropdown.Menu>
      </Dropdown>
    </div>
  );
}
